import { Component, OnInit } from '@angular/core';
import { ConfirmationService, Message, SelectItem } from 'primeng/api';
import { Zona } from '../../_models/zona';
import { Router } from '@angular/router';
import { NavService } from '../../_services/_nav.service';
import { ZonaService } from '../../_services/zona.service';
import { EstructuraFisicaService } from '../../_services/estructura-fisica.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TerceroZonaService } from '../../_services/tercero-zona.service';
import { TerceroZona } from '../../_models/tercero-zona';
import { GrupoZonaService } from '../../_services/grupo-zona.service';
import { forkJoin } from 'rxjs';
import { GrupoZona } from '../../_models/grupo-zona';
import { of } from 'rxjs';

@Component( {
  selector: 'app-zonas-transferencia',
  templateUrl: 'zonas-transferencia.component.html',
} )

export class ZonasTransferenciaComponent implements OnInit {

  msgs: Message;
  valEstructuraActual: string;
  valEstructuraTraslado: string;
  zonaActual: any[] = [];
  zonaDestino: any[] = [];
  dropEstructuraActual: SelectItem[] = [];
  dropEstructuraDestino: SelectItem[] = [];
  estructuras: any[] = [];
  selectedZona: Zona = new Zona();
  cambios = false;
  guardEstAc: any;
  guardEstTras: any;
  esconderPanel = false;
  historial: any[] = [];
  decidioActual = true;
  decidioTraslado = true;
  guardando = false;
  zonaA: Zona = new Zona();
  zonaB: Zona = new Zona();
  zonSeleccionada: Zona = new Zona();
  columnas: any[] = [];
  mosDialogo = false;
  carInformacionDialogo = false;
  formulario: FormGroup;
  guaZonas = false;
  submitted = false;
  idEstructura: string;
  carInformacionInicial = false;
  pasaA = false;
  exiNombre = false;
  validandoIndicador:boolean = false;


  constructor( private router: Router,
               private navService: NavService,
               private zonesService: ZonaService,
               private confirmationService: ConfirmationService,
               private terZonasServicio: TerceroZonaService,
               private fb: FormBuilder,
               private gruZonaServicio: GrupoZonaService,
               private estructuraFisicaService: EstructuraFisicaService ) {

  }

  ngOnInit() {
    this.formulario = this.fb.group( {
      nombre: [ null, [ Validators.required, Validators.maxLength( 50 ) ] ]
    } );
    this.valEstructuraActual = null;
    this.valEstructuraTraslado = null;
    this.selectedZona = null;
    this.estructuraFisicaService.getAllEnabled().subscribe( data => {
      data.map( ( s: any ) => {
        this.estructuras.push( { label: s.estructuraFisica, value: s.idEstructuraFisica } );
        this.dropEstructuraActual.push( { label: s.estructuraFisica, value: s.idEstructuraFisica } );
        this.dropEstructuraDestino.push( { label: s.estructuraFisica, value: s.idEstructuraFisica } );
      } );

    } );

    // this.loadHistorial();
  }

  goBack(): void {
    if ( this.cambios ) {
      this.confirmationService.confirm( {
        message: this.navService.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navService.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.repintar();
        }
      } );
    } else {
      this.repintar();
    }
  }

  get f() {
    return this.formulario.controls;
  }

  changeEstructuraActual( event: any ) {

    if ( this.cambios ) {
      this.decidioActual = false;
      this.confirmationService.confirm( {
        message: this.navService.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navService.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.zonaActual = [];
          this.zonesService.getAllByEstructuraFisica( event.value ).subscribe( data => {
            this.zonaActual = data.filter( item => item.indicadorHabilitado );
          } );
          this.dropEstructuraDestino = [];
          this.dropEstructuraDestino = this.estructuras.filter( item => item.value !== event.value );
          this.guardEstAc = event.value;
          this.zonaDestino = [];
          this.zonesService.getAllByEstructuraFisica( this.valEstructuraTraslado )
            .subscribe( data => {
              this.zonaDestino = data.filter( item => item.indicadorHabilitado );
            } );
          this.cambios = false;
          this.decidioActual = true;
        },
        reject: () => {
          this.valEstructuraActual = this.guardEstAc;
          this.decidioActual = true;
        }
      } );
    } else {
      this.zonaActual = [];
      this.zonesService.getAllByEstructuraFisica( event.value ).subscribe( data => {
        this.zonaActual = data.filter( item => item.indicadorHabilitado );
      } );
      this.dropEstructuraDestino = [];
      this.dropEstructuraDestino = this.estructuras.filter( item => item.value !== event.value );
      this.guardEstAc = event.value;
    }

  }

  changeEstructuraTraslado( event: any ) {

    if ( this.cambios ) {
      this.decidioTraslado = false;
      this.confirmationService.confirm( {
        message: this.navService.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navService.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {

          this.zonaDestino = [];
          this.zonesService.getAllByEstructuraFisica( event.value ).subscribe( data => {
            this.zonaDestino = data.filter( item => item.indicadorHabilitado );
          } );
          this.dropEstructuraActual = [];
          this.dropEstructuraActual = this.estructuras.filter( item => item.value !== event.value );
          this.guardEstTras = event.value;
          this.zonaActual = [];
          this.zonesService.getAllByEstructuraFisica( this.valEstructuraActual ).subscribe( data => {
            this.zonaActual = data.filter( item => item.indicadorHabilitado );

          } );

          this.cambios = false;
          this.decidioTraslado = true;
        },
        reject: () => {

          this.valEstructuraTraslado = this.guardEstTras;
          this.decidioTraslado = true;
        }
      } );
    } else {

      this.zonaDestino = [];
      this.zonesService.getAllByEstructuraFisica( event.value ).subscribe( data => {
        this.zonaDestino = data.filter( item => item.indicadorHabilitado );
      } );
      this.dropEstructuraActual = [];
      this.dropEstructuraActual = this.estructuras.filter( item => item.value !== event.value );
      this.guardEstTras = event.value;
    }

  }

  traZona( value: any ) {
    this.selectedZona = value.value[ 0 ];
  }

  trasladar() {
    if ( this.selectedZona !== null && this.valEstructuraTraslado !== null ) {
      this.esconderPanel = true;
      this.confirmationService.confirm( {
        message: this.navService.buscarMensaje( 'ZONES.MSG_TRASLADOZONAS' ),
        header: this.navService.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.transfer();
          this.esconderPanel = false;
        },
        reject: () => {
          this.esconderPanel = false;
        }
      } );
    } else {
      this.navService.setMesage( 0, {
        severity: 'info', summary: 'Info', detail: this.navService.buscarMensaje( 'ZONES.MSG_SELECCIONEZONA' )
      } );

    }
  }

  transfer() {

    this.selectedZona.idEstructuraFisica = this.valEstructuraTraslado;
    this.zonaDestino.push( this.selectedZona );
    this.cambios = true;
    this.zonaActual = this.zonaActual.filter( item => item.idZona !== this.selectedZona.idZona );
    this.selectedZona = null;
  }

  repintar() {
    this.valEstructuraActual = null;
    this.valEstructuraTraslado = null;
    this.zonaActual = [];
    this.zonaDestino = [];
    this.cambios = false;
    this.selectedZona = null;
    this.dropEstructuraDestino = this.estructuras;
    this.dropEstructuraActual = this.estructuras;
  }

  addZones() {
    if ( this.cambios ) {
      this.confirmationService.confirm( {
        message: this.navService.buscarMensaje( 'ZONES.MSG_TRASLADOZONAS' ),
        header: this.navService.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.add();
        }
      } );
    } else {
      this.navService.setMesage( 0, {
        severity: 'info', summary: 'Info', detail: this.navService.buscarMensaje( 'ZONES.MSG_NOEXISTENTRASLADAR' )
      } );
      this.repintar();
    }
  }

  add() {
    this.guardando = true;
    this.zonesService.updateBulk( this.zonaDestino ).subscribe( data => {
      this.navService.setMesage( 2, this.msgs );
      this.valEstructuraActual = null;
      this.valEstructuraTraslado = null;
      this.zonaActual = [];
      this.zonaDestino = [];
      this.cambios = false;
      this.selectedZona = null;
      this.guardEstTras = null;
      this.guardEstAc = null;
      this.dropEstructuraDestino = this.estructuras;
      this.dropEstructuraActual = this.estructuras;
      // this.loadHistorial();
      this.guardando = false;
    } );
  }

  loadHistorial() {
    this.historial = [];
    this.zonesService.getHistoriyTransfer().subscribe( data => {
      this.historial = data;
    } );
  }

  limpiar() {
    this.valEstructuraActual = null;
    this.valEstructuraTraslado = null;
    this.zonaActual = [];
    this.zonaDestino = [];
    this.zonSeleccionada = new Zona();
    this.zonaA = new Zona();
    this.zonaB = new Zona();
    this.dropEstructuraActual = this.estructuras;
    this.dropEstructuraDestino = this.estructuras;
  }

  regZonas() {
    this.mosDialogo = false;
  }

  trasladarZona( zona: Zona, idEstructura: string, esA: boolean ) {
    this.pasaA = esA;
    if ( ((this.pasaA && this.zonaB && (this.zonaB.idZona !== '' && this.zonaB.idZona !== null && this.zonaB.idZona !== undefined)) || (!this.pasaA && this.zonaA && (this.zonaA.idZona !== '' && this.zonaA.idZona !== null && this.zonaA.idZona !== undefined))) && (idEstructura !== '' && idEstructura !== null && idEstructura !== undefined) ) {
      this.validandoIndicador = true;
      this.zonesService.get(zona.idZona).subscribe((response) => {
        if ( response.indicadorDescargado !== null && response.indicadorDescargado === true){
          this.navService.setMesage( 0,
            {
              severity: 'info',
              summary: this.navService.buscarMensaje( 'LBL_ADVERTENCIA' ),
              detail: this.navService.buscarMensaje( 'ZONES.MSG_ERROREDITARZONA')
            } );
          this.validandoIndicador = false;
        } else{
          this.validandoIndicador = false;
          this.zonSeleccionada = zona;
          this.idEstructura = idEstructura;
          this.formulario.reset();
          this.submitted = false;
          this.mosDialogo = true;
        }
      },
        e => console.log(e));
    } else if ( !idEstructura ) {
      this.navService.setMesage( 0, {
        severity: 'info', summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navService.buscarMensaje( 'ZONES.MSG_SELECCIONEESTRUCTURA' )
      } );
    } else {
      this.navService.setMesage( 0, {
        severity: 'info', summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navService.buscarMensaje( 'ZONES.MSG_SELECCIONEZONATRASLADAR' )
      } );
    }
  }

  cambiarEstructura( idEstructura: string, estructuraA: boolean ) {
    this.carInformacionInicial = true;
    this.zonesService.getAllByEstructuraFisica( idEstructura ).subscribe( data => {
      if ( estructuraA ) {
        this.zonaActual = [];
        this.zonaA = new Zona();
        this.zonaActual = data.filter( item => item.indicadorHabilitado );
        this.dropEstructuraDestino = this.estructuras.filter( x => x.value !== idEstructura );
      } else {
        this.zonaDestino = [];
        this.zonaB = new Zona();
        this.zonaDestino = data.filter( item => item.indicadorHabilitado );
        this.dropEstructuraActual = this.estructuras.filter( x => x.value !== idEstructura );
      }
      this.carInformacionInicial = false;
    } );
  }

  cambiarNombre() {
    this.submitted = true;
    this.validarNombre( this.pasaA ? this.zonaActual : this.zonaDestino );
    if ( this.formulario.valid && !this.exiNombre ) {
      this.zonesService.get(this.zonSeleccionada.idZona).subscribe((response) => {
        if ( response.indicadorDescargado !== null && response.indicadorDescargado === true){
          this.navService.setMesage( 0,
            {
              severity: 'info',
              summary: this.navService.buscarMensaje( 'LBL_ADVERTENCIA' ),
              detail: this.navService.buscarMensaje( 'ZONES.MSG_ERROREDITARZONA')
            } );
          this.submitted = false;
        } else{
          this.guaZonas = true;
          const a = this.formulario.value;
          const b = Object.assign( {}, this.zonSeleccionada );
          b.nombre = a.nombre;
          b.idEstructuraFisica = this.idEstructura;
          this.zonesService.update( b ).subscribe( zonActu => {
            forkJoin( this.terZonasServicio.obtenerPorZonas( b.idZona ),
              this.gruZonaServicio.listadoPorZona( b.idZona ) ).subscribe( ( [ terZonas, lisGrupoZona ] ) => {
              const regGrupZonaActualizar = [];
              lisGrupoZona.map( ( s: GrupoZona ) => {
                if ( s.indicadorHabilitado ) {
                  s.indicadorHabilitado = false;
                  regGrupZonaActualizar.push( s );
                }
              } );
              const peticiones = [];
              if ( terZonas.length > 0 ) {
                terZonas.map( ( s: TerceroZona ) => {
                  s.indicadorHabilitado = false;
                } );
                peticiones.push( this.terZonasServicio.bulk( terZonas ) );
              }
              if ( regGrupZonaActualizar.length > 0 ) {
                peticiones.push( this.gruZonaServicio.bulk( regGrupZonaActualizar ) );
              }
              if ( peticiones.length > 0 ) {
                forkJoin( peticiones ).subscribe( rta => {
                  this.validarZonas( b );
                  this.navService.setMesage( 2 );
                } );
              } else {
                this.validarZonas( b );
                this.navService.setMesage( 2 );
              }
            } );
          } );
        }
      });
    }
  }

  validarZonas( b: any ) {
    let indice = -1;
    if ( this.pasaA ) {
      indice = this.zonaDestino.findIndex( x => x.idZona === this.zonSeleccionada.idZona );
      if ( indice >= 0 ) {
        this.zonaDestino.splice( indice, 1 );
      }
      this.zonaActual.push( b );
    } else {
      indice = this.zonaActual.findIndex( x => x.idZona === this.zonSeleccionada.idZona );
      if ( indice >= 0 ) {
        this.zonaActual.splice( indice, 1 );
      }
      this.zonaDestino.push( b );
    }
    this.guaZonas = false;
    this.mosDialogo = false;
  }

  validarNombre( zonas: any ) {
    this.exiNombre = zonas.find( x => x.zona === this.formulario.controls.nombre.value ) != undefined ? true : false;
  }

  validarDisponibilidadZona$(idZona:string){
    //return this.zonesService.getIndicadorEdicionZona(idZona);
    let b = true;
    let a = of(b);
    return a;
  }


}
